import {Component} from '@angular/core';

@Component({
    selector: 'app-forgot-password-layout',
    standalone: false,
    templateUrl: './forgot-password-layout.component.html',
    styleUrls: ['./forgot-password-layout.component.scss']
})
export class ForgotPasswordLayoutComponent {

}
